import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import CheckOtherParentDataResult from "../models/Person/CheckOtherParentDataResult";

const personsUrlPrefix = "persons";

interface CheckOtherParentDataParams {
  firstName: string;
  lastName: string;
  oib: string;
  childOib: string;
}

export const personsApi = createApi({
  reducerPath: "personsApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    checkOtherParentData: build.mutation<
      CheckOtherParentDataResult,
      CheckOtherParentDataParams
    >({
      query: (data) => ({
        url: `${personsUrlPrefix}/other-parents/check-data`,
        method: "get",
        data,
      }),
    }),
  }),
});

export const { useCheckOtherParentDataMutation } = personsApi;
